<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card no-shadow mt-0">
            <div class="
                card-header card-header-primary
                negative
                blue-grad
                w-50
                d-flex
                flex-column
              ">
              <h4 class="card-title">
                {{ $t("message.case_filling_info.title") }}
              </h4>
            </div>
            <div class="card-body w-100 mt-3">
              <b-tabs pills content-class="mt-3" small v-model="tab_index">
                <b-tab :title="$t('message.case_filling_info.search')" active id="search-tab">
                  <div class="input-group">
                    <input type="text" class="form-control" style="height: 50px" :disabled="isSearching" :placeholder="$t('message.case_filling_info.search_keyword_placeholder')
                      " v-model="searchKeyword" autocomplete="off" />

                    <div class="togglebutton my-auto mx-4 form-label-group">
                      <label class="control-label-sm">
                        <br />
                        <input type="checkbox" v-model="searchType" :disabled="isSearching" />
                        <span class="toggle"></span>
                        <span class="female">{{ $t("message.case_filling_info.vocabulary.defendant") }}</span>
                        <span class="male">{{ $t("message.case_filling_info.vocabulary.prosecutor") }}</span>
                      </label>
                    </div>

                    <div class="input-group-append">
                      <button v-if="!isSearching" class="btn btn-primary" type="button" @click="() => search()"
                        style="height: 50px">
                        {{ $t("message.case_filling_info.search") }}
                      </button>
                      <button v-else class="btn btn-primary" type="button" disabled style="height: 50px">
                        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                        {{ $t("message.case_filling_info.searching") }}...
                      </button>
                    </div>
                  </div>
                  <div class="mt-2" v-if="input_error" style="color: red;">{{ $t('message.code_must_be_12_symbols') }}
                  </div>
                  <div class="mt-3">
                    <div v-if="isSearching">
                      <h4>{{ $t("message.case_filling_info.searching") }}...</h4>
                    </div>
                    <div v-else-if="isSearched && !resultsExists">
                      {{ $t("message.case_filling_info.no_results") }}
                    </div>
                    <div v-else-if="isSearched && resultsExists" class="mt-4">
                      <div class="mr-0 ml-auto mb-3" style="width: fit-content">
                        <js-pdf :pageMarginsInPx="[30, 30, 30, 30]" :pageFullWidthInPx="1400" :filename="'detail.pdf'">
                          <template v-slot="pdfProps">
                            <itemsList :data="responses[String(page)].Result.Data"
                              :imLoaded="pdfProps.childFullyLoaded" />
                          </template>
                        </js-pdf>
                      </div>
                      <itemsList :data="responses[String(page)].Result.Data" />
                      <b-pagination v-model="exposedPage" :total-rows="Object.values(responses)[0].Paging.TotalRecords"
                        :per-page="pageSize"></b-pagination>
                    </div>
                  </div>
                </b-tab>
                <b-tab :title="$t('message.case_filling_info.history')" lazy id="history-tab">
                  <History />
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import History from "./history.vue";
import itemsList from "./itemsList.vue";

export default {
  inject: ["runBiller", "updateBiller"],
  components: { History, itemsList },
  data() {
    return {
      tab_index: 0,
      page: 1,
      exposedPage: 1,
      pageSize: 20, // max possible 20
      isSearching: false,
      isSearched: false,
      searchKeyword: "",
      searchType: true, // true = defendant (default), false = prosecutor
      responses: {},
      input_error: false,
    };
  },
  async mounted() {
    if (!this.$store.state.auth) this.$router.push({ name: "sign-in" });
  },
  methods: {
    validateSearchKeyword() {
      if (!isNaN(Number(this.searchKeyword)) && ![15, 18].includes(this.searchKeyword.length)) {
        this.input_error = true;
        return false;
      }
      this.input_error = false;
      return true;
    },
    async search(newPage = null) {
      if (newPage === null) {
        this.resetState();
        if (!this.validateSearchKeyword()) {
          return;
        }
      }

      if (newPage && this.responses[newPage]) return true;

      this.isSearching = true;
      const reduceBalanceId = await this.runBiller("889", this.searchKeyword, false);
      if (!reduceBalanceId) {
        this.isSearching = false;
        return false;
      }

      this.isSearched = false;
      try {
        const url = window.base + "/Library/CaseFilingInformationSearch?keyWord=" +
          this.searchKeyword +
          "&caseIdentity=" +
          (this.searchType === true ? 1 : 2) +
          "&pageIndex=" +
          String(newPage || this.page) +
          "&pageSize=" +
          this.pageSize;
        const res = await axios.get(url);
        this.responses[String(newPage || this.page)] = res.data;
        this.isSearched = true;
        this.isSearching = false;
        return true;
      } catch (e) {
        this.isSearched = true;
        this.isSearching = false;
        console.error("Case Filling Info Service Error:", e);
        if (error.message === 'Network Error') {
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.request_error_messages.connection_issue"),
            timeout: 5000,
          }).show();
        }
        return false;
      }
    },
    resetState() {
      this.page = 1;
      this.exposedPage = 1;
      this.pageSize = 20;
      this.isSearching = false;
      this.isSearched = false;
      this.responses = {};
    },
  },
  computed: {
    resultsExists() {
      return Boolean(this.responses[String(this.page)]?.Result?.Data?.at(0));
    },
  },
  watch: {
    async exposedPage(newVal) {
      const success = await this.search(newVal);
      if (success) {
        this.page = newVal;
      } else {
        this.exposedPage = this.page;
      }
    },
    searchKeyword(newVal) {
      this.input_error = false;
    },
  }
};
</script>
<style>
.modal-footer .btn.btn-success.btn-sm:hover {
  background-color: #4caf50 !important;
  border-color: #4caf50 !important;
}

.modal-footer .btn.btn-secondary.btn-sm:hover {
  color: #333333 !important;
}
</style>
